import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe("pk_test_51Rq65BGgIqJ5Tz6mize4UsxdCwNuA8LkXtvGAxaGoxkSZnz3S5hmFsOhbnwc0swsCg5yRbtvmDD3tLrNCpJewkXh005YJKZfaX");

const PaymentPage = () => {
  const [stripe, setStripe] = useState(null);
  const [card, setCard] = useState(null);

  // ✅ INIT STRIPE
useEffect(() => {
  if (!window.location.pathname.includes("/payment")) return;

  const initStripe = async () => {
    const stripeInstance = await stripePromise;

    const numberEl = document.getElementById("card-number");
    const expiryEl = document.getElementById("card-expiry");
    const cvcEl = document.getElementById("card-cvc");

    if (!numberEl || !expiryEl || !cvcEl) return;
    if (numberEl.hasChildNodes()) return;

    const elements = stripeInstance.elements();

    const style = {
          base: {
            fontSize: "14px",
            fontWeight: "600",
            fontFamily: '"Outfit", system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
            color: "#131E29",
            fontSmoothing: "antialiased",
            "::placeholder": {
              color: "#888",
              fontFamily: '"Outfit", sans-serif',
            },
          },
          invalid: {
            color: "#dc3545",
          },
        };

    const cardNumber = elements.create("cardNumber", {
          style,
          placeholder: ""
        });

        const cardExpiry = elements.create("cardExpiry", {
          style,
          placeholder: ""
        });

        const cardCvc = elements.create("cardCvc", {
          style,
          placeholder: ""
        });

    cardNumber.mount(numberEl);
    cardExpiry.mount(expiryEl);
    cardCvc.mount(cvcEl);

    // ✅ FIX: Handle UI properly
    const handleStripeUI = (element, container) => {
      element.on("focus", () => {
        container.classList.add("stripe-focus");
        container.classList.add("has-focus"); // ✅ ADD THIS
      });

      element.on("blur", () => {
        container.classList.remove("stripe-focus");
        container.classList.remove("has-focus"); // ✅ ADD THIS
      });

      element.on("change", (event) => {
        if (event.empty) {
          container.classList.remove("has-value");
        } else {
          container.classList.add("has-value");
        }
      });
    };
    const inputs = document.querySelectorAll(".custom-floating input");

    inputs.forEach((input) => {
      const wrapper = input.closest(".custom-floating");

      const updateState = () => {
        if (input.value.trim() !== "") {
          wrapper.classList.add("has-value");
        } else {
          wrapper.classList.remove("has-value");
        }
      };

      input.addEventListener("input", updateState);
      input.addEventListener("blur", updateState);
      input.addEventListener("focus", () => {
        wrapper.classList.add("stripe-focus"); // reuse style
      });
    });
    const numberWrap = numberEl.closest(".custom-floating");
    const expiryWrap = expiryEl.closest(".custom-floating");
    const cvcWrap = cvcEl.closest(".custom-floating");

    handleStripeUI(cardNumber, numberWrap);
    handleStripeUI(cardExpiry, expiryWrap);
    handleStripeUI(cardCvc, cvcWrap);

    // ✅ Button enable logic
    let n = false, e = false, c = false;

    const updateBtn = () => {
      const btn = document.getElementById("pay-btn");
      if (btn) btn.disabled = !(n && e && c);
    };

    cardNumber.on("change", ev => { n = ev.complete; updateBtn(); });
    cardExpiry.on("change", ev => { e = ev.complete; updateBtn(); });
    cardCvc.on("change", ev => { c = ev.complete; updateBtn(); });

    setStripe(stripeInstance);
    setCard({ cardNumber });
  };

  setTimeout(initStripe, 200);
}, []);

  // ✅ PAYMENT SUBMIT
  useEffect(() => {
    if (!window.location.pathname.includes("/payment")) return;

    const attach = () => {
      const form = document.getElementById("payment-form");
      if (!form) return setTimeout(attach, 200);

      const submit = async (e) => {
        e.preventDefault();

        if (!stripe || !card) return;

        const loanPk = document.getElementById("loan-pk")?.value;
        const csrf = document.querySelector('[name=csrfmiddlewaretoken]')?.value;

        const name = document.getElementById("cardholder-name")?.value;
        const email = document.getElementById("cardholder-email")?.value;
        const addressInput = document.getElementById("cardholder-address");
        const address = addressInput?.value;
        const billingAddress = readBillingAddress(addressInput);
        if (!billingAddress) {
          // page-loader.js shows its overlay on every payment-form submit.
          if (window.App && typeof window.App.hidePageLoader === "function") {
            window.App.hidePageLoader(true);
          }
          showBillingAddressError(BILLING_ADDRESS_HINT);
          addressInput?.focus();
          return;
        }

        const btn = document.getElementById("pay-btn");

        try {
          if (btn) btn.disabled = true;
          if (window.App && typeof window.App.showPageLoader === "function") {
            window.App.showPageLoader({ animate: false });
          }

          const res = await fetch("/create-payment-intent/", {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-CSRFToken": csrf,
            },
            body: JSON.stringify({
              cardholder_name: name,
              cardholder_email: email,
              cardholder_address: address,
              loan_pk: loanPk,
            }),
          });

          const data = await res.json();
          if (!res.ok) {
            if (data && data.field === "billing_address") showBillingAddressError(data.error);
            throw new Error();
          }

          const result = await stripe.confirmCardPayment(data.clientSecret, {
            payment_method: {
              card: card.cardNumber,
              billing_details: {
                name,
                email,
                address: billingAddress,
              },
            },
          });

          if (result.paymentIntent?.status === "succeeded") {
            window.location.href = `/confirm-payment/?loan_pk=${loanPk}`;
          } else {
            if (window.App && typeof window.App.hidePageLoader === "function") {
              window.App.hidePageLoader(true);
            }
            if (btn) btn.disabled = false;
          }

        } catch {
          if (window.App && typeof window.App.hidePageLoader === "function") {
            window.App.hidePageLoader(true);
          }
          if (btn) btn.disabled = false;
        }
      };

      form.addEventListener("submit", submit);
      return () => form.removeEventListener("submit", submit);
    };

    const cleanup = attach();
    return cleanup;

  }, [stripe, card]);

  useEffect(() => {
    if (!window.location.pathname.includes("/payment")) return;

    const loadGoogle = () => {
      if (window.google && window.google.maps && window.google.maps.places && window.google.maps.places.Autocomplete) {
        initAuto();
        return;
      }

      const existingScript = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
      if (existingScript) {
        existingScript.addEventListener("load", initAuto, { once: true });
        return;
      }

      const keyMeta = document.querySelector('meta[name="google-maps-api-key"]');
      const apiKey = keyMeta ? keyMeta.content.trim() : "";
      if (!apiKey) {
        console.error("Google address autocomplete requires GOOGLE_MAPS_API_KEY.");
        return;
      }

      const script = document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(apiKey) + "&libraries=places";
      script.async = true;
      script.defer = true;
      script.onload = initAuto;
      script.onerror = () => console.error("Google Maps Places API failed to load.");

      document.head.appendChild(script);
      };

      const initAuto = () => {
        const input = document.getElementById("cardholder-address");
        if (!input || input.dataset.googleAutocompleteInit || !window.google?.maps?.places?.Autocomplete) return;

        const autocomplete = new window.google.maps.places.Autocomplete(input, {
          types: ["address"],
          componentRestrictions: { country: "us" }, // change if needed
        });

        autocomplete.setFields(["address_components", "formatted_address"]);
        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          const picked = billingAddressFromPlace(place);
          if (place?.formatted_address) {
            input.value = place.formatted_address;
          }
          if (picked) {
            input.dataset.billingAddress = JSON.stringify(picked);
            input.dataset.billingAddressText = input.value;
            showBillingAddressError("");
          } else {
            delete input.dataset.billingAddress;
            showBillingAddressError(BILLING_ADDRESS_HINT);
          }
        });
        // Typing after a pick means the picked address no longer applies.
        input.addEventListener("input", () => {
          if (input.value !== input.dataset.billingAddressText) delete input.dataset.billingAddress;
        });
        input.dataset.googleAutocompleteInit = "1";
      };

      loadGoogle();
    }, []);

     useEffect(() => {

    const el = document.getElementById("redirect-data");

        if (!el) return;

        const redirectUrl = el.dataset.url;

        if (redirectUrl) {
          setTimeout(() => {
            window.location.href = redirectUrl;
          }, 2000);
        }

  }, []);

  return null;
};

// The billing address must be complete: picked from Google's suggestions, or
// typed in full as "street, city, state ZIP". A half-finished one (no street
// number, no ZIP) is not accepted.
const BILLING_ADDRESS_HINT =
  "Enter your full billing address (street number, street, city, state and ZIP code), or choose it from the list.";

function billingAddressFromPlace(place) {
  const parts = {};
  (place?.address_components || []).forEach((c) => {
    (c.types || []).forEach((type) => { parts[type] = c; });
  });
  const number = parts.street_number?.long_name;
  const street = parts.route?.short_name || parts.route?.long_name;
  const zip = parts.postal_code?.long_name;
  if (!number || !street || !zip) return null;
  const city = (parts.locality || parts.sublocality || parts.postal_town || parts.administrative_area_level_3)?.long_name;
  return {
    line1: `${number} ${street}`,
    city: city || "",
    state: parts.administrative_area_level_1?.short_name || "",
    postal_code: parts.postal_code_suffix ? `${zip}-${parts.postal_code_suffix.long_name}` : zip,
    country: parts.country?.short_name || "US",
  };
}

function readBillingAddress(input) {
  if (!input) return null;
  try {
    const picked = JSON.parse(input.dataset.billingAddress || "null");
    if (picked && input.value === input.dataset.billingAddressText) return picked;
  } catch (err) {
    // fall through: nothing usable was picked
  }
  // Nothing picked (or Google didn't load): a complete typed address is fine,
  // "street, city, state ZIP" - the same rule the server applies.
  return typedBillingAddress(input.value);
}

function typedBillingAddress(text) {
  const parts = (text || "").split(",").map((p) => p.trim()).filter(Boolean);
  const zip = (text || "").match(/\b(\d{5}(?:-\d{4})?)\b/);
  if (parts.length < 3 || !zip || !/^\d+(?:-\d+)?[A-Za-z]?\s+\S+/.test(parts[0])) return null;
  const stateZip = parts.find((p) => p.includes(zip[1])) || "";
  return {
    line1: parts[0],
    city: parts[1],
    state: stateZip.replace(zip[1], "").trim(),
    postal_code: zip[1],
    country: "US",
  };
}

function showBillingAddressError(message) {
  const input = document.getElementById("cardholder-address");
  const box = document.getElementById("billing-address-error");
  if (box) {
    box.textContent = message || "";
    box.classList.toggle("d-none", !message);
  }
  if (input) input.classList.toggle("is-invalid", !!message);
}

export default PaymentPage;
